const furniture = [
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Furniture_trend_web_20012021_1_n.jpg", title: "Velvet Tables" },
  { imgUrl: "https://ii1.pepperfry.com/media/wysiwyg/banners/Furniture_trend_web_20012021_2_n.jpg", title: "Bamboos & Clone" },
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/Furniture_trend_web_20012021_3_n.jpg", title: "Painted By Hand" },
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Furniture_trend_web_20012021_4_n.jpg", title: "Glamorous Metals" },
];

const sofa = [
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Sofasrecliners_trends_web_20012021_2x_1.jpg", title: "Pretty In Prints" },
  { imgUrl: "https://ii1.pepperfry.com/media/wysiwyg/banners/Sofasrecliners_trends_web_20012021_2x_2.jpg", title: "Small Is Stylish" },
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/Sofasrecliners_trends_web_20012021_2x_3.jpg", title: "Convertibles" },
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Sofasrecliners_trends_web_20012021_2x_4.jpg", title: "Charming Curves" },
];

const beds = [
  {
    imgUrl:
      "https://ii3.pepperfry.com/media/wysiwyg/banners/Web_Beds_Trends_01_2X_29042022.jpg",
    title: "Dreamy Poster Beds",
  },
  {
    imgUrl:
      "https://ii1.pepperfry.com/media/wysiwyg/banners/Web_Beds_Trends_02_2X_29042022.jpg",
    title: "Oh-So-Plush",
  },
  {
    imgUrl:
      "https://ii2.pepperfry.com/media/wysiwyg/banners/Web_Beds_Trends_03_2X_29042022.jpg",
    title: "Easy Lift",
  },
  {
    imgUrl:
      "https://ii3.pepperfry.com/media/wysiwyg/banners/Web_Beds_Trends_04_2X_29042022.jpg",
    title: "Spine Loving",
  },
];

const storage = [
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Web_Storage_Trends_1_2x_29042022.jpg", title: "Kid's Wardrobes" },
  { imgUrl: "https://ii1.pepperfry.com/media/wysiwyg/banners/Web_Storage_Trends_2_2x_29042022.jpg", title: "Industrial Cabinets & Sideboards" },
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/Web_Storage_Trends_3_2x_29042022.jpg", title: "Decorative Boxes" },
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Web_Storage_Trends_4_2x_29042022.jpg", title: "3 Door Wardrobes" },
];

const dinning = [
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Trends_01_DiningBarCLP_Web_2X_22072022.jpg", title: "Tea Sets" },
  { imgUrl: "https://ii1.pepperfry.com/media/wysiwyg/banners/Trends_02_DiningBarCLP_Web_2X_22072022.jpg", title: "Upholstered Side Dining Chair" },
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/Trends_03_DiningBarCLP_Web_2X_22072022.jpg", title: "Dinner Bowls" },
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Trends_04_DiningBarCLP_Web_2X_22072022.jpg", title: "Appetizer Plates" },
];

const wall = [
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/wallshelves_trend_web_23122021_1.jpg", title: "Offbeat Shapes" },
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/wallshelves_trend_web_23122021_2.jpg", title: "Naturals & Neutral" },
  { imgUrl: "https://ii1.pepperfry.com/media/wysiwyg/banners/wallshelves_trend_web_23122021_3.jpg", title: "Traditional" },
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/wallshelves_trend_web_23122021_4.jpg", title: "Touch Of Metal" },
];

const decor = [
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Decor_Trend_Section_WEB_1_2x.jpg", title: "Decorative Mirrors" },
  { imgUrl: "https://ii1.pepperfry.com/media/wysiwyg/banners/Decor_Trend_Section_WEB_2_2x.jpg", title: "Wall Clocks" },
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/Decor_Trend_Section_WEB_3_2x.jpg", title: "Wall Shelves" },
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Decor_Trend_Section_WEB_4_2x.jpg", title: "Barware" },
];

const light = [
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Lighting_Trend_Section_WEB_1_2x_28012021.jpg", title: "The Elite's Choice" },
  { imgUrl: "https://ii1.pepperfry.com/media/wysiwyg/banners/Lighting_Trend_Section_WEB_2_2x_28012021.jpg", title: "In This Season" },
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/Lighting_Trend_Section_WEB_3_2x_28012021.jpg", title: "Home Smart Home" },
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Lighting_Trend_Section_WEB_4_2x_28012021.jpg", title: "Big Savings" },
];

const furnishing = [
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/Furninshing_Trend_Section_WEB_1_2x.jpg", title: "Door Curtains" },
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Furninshing_Trend_Section_WEB_2_2x.jpg", title: "Floral Carpets" },
  { imgUrl: "https://ii1.pepperfry.com/media/wysiwyg/banners/Furninshing_Trend_Section_WEB_3_2x.jpg", title: "Bed Sheets" },
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/Furninshing_Trend_Section_WEB_4_2x.jpg", title: "Cushion Covers" },
];

const carpets = [
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Flooring_Trends_Web_2X_1_17032022.jpg", title: "Geometric Dhurries" },
  { imgUrl: "https://ii1.pepperfry.com/media/wysiwyg/banners/Flooring_Trends_Web_2X_2_17032022.jpg", title: "Hallway Runners" },
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/Flooring_Trends_Web_2X_3_17032022.jpg", title: "Abstract Dhurries" },
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Flooring_Trends_Web_2X_4_17032022.jpg", title: "Hand Woven Durries" },
];

const garden = [
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Homegarden_trends_web_24122021_1.jpg", title: "Desk Pots" },
  { imgUrl: "https://ii1.pepperfry.com/media/wysiwyg/banners/Homegarden_trends_web_24122021_2.jpg", title: "Hanging Planters" },
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/Homegarden_trends_web_24122021_3.jpg", title: "Artificial FLowers" },
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Homegarden_trends_web_24122021_4.jpg", title: "Decorative Pebbles" },
];

const appliances = [
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Trends_01_Web_AppliancesCLP_2X_08082022.jpg", title: "Robotic Vaccum Cleaner" },
  { imgUrl: "https://ii1.pepperfry.com/media/wysiwyg/banners/Trends_02_Web_AppliancesCLP_2X_08082022.jpg", title: "Washing Machines" },
  { imgUrl: "https://ii2.pepperfry.com/media/wysiwyg/banners/Trends_03_Web_AppliancesCLP_2X_08082022.jpg", title: "Water Purifies" },
  { imgUrl: "https://ii3.pepperfry.com/media/wysiwyg/banners/Trends_04_Web_AppliancesCLP_2X_08082022.jpg", title: "Water Geysers" },
];


module.exports = {furnishing, furniture , appliances , garden, carpets , light , decor ,wall , dinning , beds, sofa, storage}
